// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import'element-ui/lib/theme-chalk/index.css';//引入element-ui的样式文件
import echarts from 'echarts'
import getSystem from "./utils/getSystem";
import './assets/css/font.css'//引入字体


import './assets/css/global.css';//引入全局样式表
// import './components/Description/index';


Vue.prototype.getSystem=getSystem
Vue.prototype.$echarts = echarts
Vue.use(ElementUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js